module.exports = __webpack_public_path__ + "static/thankyou-5dc3cf867b1fb2f0facb02e6c5cacd46.gif";